import {
  promotionSelector,
  usePromotionStore,
} from '@editor/stores/promotionStore';
import { SubscriptionPlan } from '@repo/domain/user';
import { useCurrentPlan } from '@repo/subscription/client';
import { Button } from '@repo/ui-kit/components/core/Button';

import { handleBuyCredits } from '../AiGenerators/utils';

import { UpgradeTrackingLabel } from './CreditsBalanceInfo';

interface UpgradePlanButtonProps {
  upgradeTrackingLabel?: UpgradeTrackingLabel;
  fitSpace?: boolean;
}

export const UpgradePlanButton: React.FC<UpgradePlanButtonProps> = ({
  upgradeTrackingLabel,
  fitSpace = false,
}) => {
  const showUpgradeModal = usePromotionStore(
    promotionSelector.showUpgradeModal
  );

  const currentPlan = useCurrentPlan();

  if (currentPlan === SubscriptionPlan.EXPERT) {
    return null;
  }

  const upgradeModalContentType =
    currentPlan === SubscriptionPlan.PRO
      ? 'upgradePlanWithMoreCreditsAsProUserAiPanel'
      : 'upgradePlanWithMoreCreditsAIPanel';

  return (
    <Button
      dataTestId="credits-balance-info-upgrade-button"
      name="upgradePlanButton"
      size="s"
      variant="secondary"
      width={fitSpace ? '100%' : 'unset'}
      onClick={(): void =>
        showUpgradeModal('noIncentiveUpgrade', {
          trackingLabel: upgradeTrackingLabel ?? upgradeModalContentType,
        })
      }
    >
      <Button.Label>Upgrade Plan</Button.Label>
    </Button>
  );
};

export const BuyCreditsButton: React.FC = () => {
  const currentPlan = useCurrentPlan();

  if (currentPlan !== SubscriptionPlan.EXPERT) {
    return null;
  }

  return (
    <Button
      dataTestId="credits-balance-info-buy-credits-button"
      name="buyCreditsButton"
      size="s"
      variant="secondary"
      width="100%"
      onClick={handleBuyCredits}
    >
      <Button.Label>Buy Credits</Button.Label>
    </Button>
  );
};
